import {SiteDTO} from './site-dto';

export class ObjectDTO {
  id = 0;
  libelle: string;
  code: string;
  actif: boolean;
  site: SiteDTO;
}
